module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAgCAYAAADwvkPPAAAAAXNSR0IArs4c6QAAAWJJREFUSEvF1s0rBWEUx/Hf90+Q/0DZsFF2FnY29hYiLxEiLxEisiFC5CVC5CUSGykb/9zR1cxt7nXvnDPdhVlNM8/59DxzznnmQZnLzPqA9+yzIvekg82sR9K3pH7gtQiSjv3FzKxL0qek5uTFIPBcFMTMOiS9SWqtCh4GHouAJawtwdprBI4C91EwXWYeOA7cRsBsAvLASeDaA8tYkog8cBq4zAMrsAA4C5zXA/9gAXAeOK0F1sQC4CJwXA3WxQLgMnCYBXOxALgK7Fe0k5dyp7DXgd2S4c4ssxHklc0msB3GAkve+h/M+W4bwE5oZg60BuyFEuBAK8BBqDQcaAk4ChWtAy0AJ6F2cqA54CzU6A40A1yEtiAHmgKuQpujA00AN14PR34oY8CdB/3WmTOjEeAhAqVYZ/LfbKkKGgKeolC5A8ysW9KHpKYkeAB4KQJVtJOZ9Ur6avjgktkAGzpS/QB2aJ0XVtRsAAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/gd/detail8.png
// module id = Mr+W
// module chunks = 1